module.exports = __webpack_public_path__ + "media/images/create_event_league-dc5deb39.svg";